import React from "react";
const SvgArrow = props => (
  <svg viewBox="0 0 12 12" {...props}>
    <path
      fill="none"
      stroke="#39434E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M5.567 1.359h5.074m0 5.074V1.359M1 10.999l9.641-9.64"
    />
  </svg>
);
export default SvgArrow;
